<script lang="ts">
	import { onMount, createEventDispatcher } from 'svelte';
	import { format } from 'svelte-i18n';
	import { Container } from '@Shelly/shelly-design-system';
	import type { ITempSchemeObj } from '../../../../types/TemperatureSchemeType';
	import { capFirstChar } from 'src/helpers/utilities';
	import SelectList from 'src/components/SelectList/SelectList.svelte';
	import { getMappedRoomList, getThermostatRoomList } from 'src/components/Lists/list-helpers';

	export let temp_scheme_object: ITempSchemeObj;
	export let selectedRef: HTMLElement = null;

	let roomListDB = [];
	let allRoomsRefs: { [key: string | number]: HTMLElement } = {};

	$: roomListMapped = getMappedRoomList(roomListDB, temp_scheme_object?._meta?.room);
	$: selectedRef = allRoomsRefs[temp_scheme_object?._meta?.room];

	const dispatch = createEventDispatcher<{ selectRoom: number }>();

	const onSelectRoom = (room) => {
		dispatch('selectRoom', room.id);
	};

	onMount(() => {
		roomListDB = [...getThermostatRoomList()];
	});
</script>

<Container padding="scrollPaddings">
	<!-- DO NOT REMOVE COMMENT: Padding references -->
	<div class="pt-s"></div>
	<SelectList
		title={capFirstChar(
			$format('select_type', {
				values: {
					type: $format('process_room', { default: 'room' }),
				},
				default: 'Select room',
			}),
		)}
		list={roomListMapped}
		variant="radio"
		bind:allCardsRefs={allRoomsRefs}
		on:click={(e) => onSelectRoom(e.detail)}
	/>
	<!-- DO NOT REMOVE COMMENT: Padding references -->
	<div class="pb-s"></div>
</Container>
